import React from 'react';
import ReactDom from 'react-dom';
import Base from './Base';

ReactDom.render(<Base />, document.getElementById('kitab-app-container'));
